import { render, staticRenderFns } from "./ManagementPartners.vue?vue&type=template&id=26599136&"
import script from "./ManagementPartners.vue?vue&type=script&lang=js&"
export * from "./ManagementPartners.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/themes/default/management.css?vue&type=style&index=0&lang=css&"
import style1 from "./ManagementPartners.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports